import { render, staticRenderFns } from "./ForumImageViewer.vue?vue&type=template&id=bca4810c&"
import script from "./ForumImageViewer.vue?vue&type=script&lang=js&"
export * from "./ForumImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ForumImageViewer.vue?vue&type=style&index=0&id=bca4810c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports